import { InlineBanner, token } from '@bynder/design-system';
import styled from 'styled-components';

export const StyledInlineBanner = styled(InlineBanner)<{ withMargin: boolean }>`
    margin-bottom: ${(withMargin) => (withMargin ? token.spacing5 : 0)};
`;
